import React from 'react'
import { TaxEstimates as TaxEstimatesView } from '@layerfi/components'
import { useNavigate } from 'react-router-dom'

import { AccountingLayout } from '../../../layouts/AccountingLayout'

export const TaxEstimates = () => {
  const navigate = useNavigate()
  return (
    <AccountingLayout>
      <TaxEstimatesView onClickReviewTransactions={() => {
        navigate('../bank-transactions')
      }} />
    </AccountingLayout>
  )
}

